import * as React from 'react';
import { useLocation } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { List as ListIcon } from '@phosphor-icons/react/dist/ssr/List';
import { useNavItems } from '../../../hooks/useNavItems';
import { useUserContext } from '../../../hooks/useUserContext';
import { BVTConstants } from '../../../utils/BVTConstants';

import { usePopover } from './../../../hooks/use-popover';

import { MobileNav } from './mobile-nav';
import { UserPopover } from './user-popover';

export function MainNav(): React.JSX.Element {
  const [openNav, setOpenNav] = React.useState<boolean>(false);
  const userPopover = usePopover<HTMLDivElement>();
  const location = useLocation();
  const navItems = useNavItems();
  const user = useUserContext();
  const navLabel = navItems.getNavLabel(location.pathname);

  return (
    <React.Fragment>
      <Box
        component="header"
        sx={{
          borderBottom: '1px solid var(--mui-palette-divider)',
          backgroundColor: 'var(--mui-palette-background-paper)',
          position: 'sticky',
          top: 0,
          zIndex: 'var(--mui-zIndex-appBar)',
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{ alignItems: 'center', justifyContent: 'space-between', minHeight: '64px', px: 2 }}
        >
          <Stack sx={{ alignItems: 'center' }} direction="row" spacing={2}>
            <IconButton
              onClick={(): void => {
                setOpenNav(true);
              }}
              sx={{ display: { lg: 'none' } }}
            >
              <ListIcon />
            </IconButton>
          <Typography
            component="span"
            sx={{ color: 'inherit', fontSize: '1.400rem', fontWeight: 500, lineHeight: '42px' }}
          >
            {navLabel}
          </Typography>
            {/* <Tooltip title="Search">
              <IconButton>
                <MagnifyingGlassIcon />
              </IconButton>
            </Tooltip> */}
          </Stack>
          <Stack sx={{ alignItems: 'center' }} direction="row" spacing={2}>
            {/* <Tooltip title="Contacts">
              <IconButton>
                <UsersIcon />
              </IconButton>
            </Tooltip> */}
            {user.status !== BVTConstants.ACTIVE && (
              <Chip
                label={user.status === BVTConstants.PARENT_INACTIVE ? BVTConstants.INACTIVE : user.status}
                size="small"
                sx={{
                  backgroundColor: 
                    user.status === BVTConstants.INACTIVE ? '#ffebee' :
                    user.status === BVTConstants.PARENT_INACTIVE ? '#ffebee' :
                    user.status === BVTConstants.SUSPENDED ? '#fff3e0' : '#f5f5f5',
                  color: 
                    user.status === BVTConstants.INACTIVE ? 'red' :
                    user.status === BVTConstants.PARENT_INACTIVE ? 'red' :
                    user.status === BVTConstants.SUSPENDED ? 'orange' : 'grey',
                  fontWeight: 'bold',
                  border: 
                    user.status === BVTConstants.INACTIVE ? '1px solid red' :
                    user.status === BVTConstants.PARENT_INACTIVE ? '1px solid red' :
                    user.status === BVTConstants.SUSPENDED ? '1px solid orange' : '1px solid grey',
                }}
              />
            )}
            <Typography
              component="span"
              sx={{ color: 'inherit', fontSize: '1.135rem', fontWeight: 400, lineHeight: '38px' }}
                >
              {user.lastName}, {user.firstName}
            </Typography>
            {/* <Tooltip title="Notifications">
              <Badge badgeContent={4} color="success" variant="dot">
                <IconButton>
                  <BellIcon />
                </IconButton>
              </Badge>
            </Tooltip> */}
            <Avatar
              onClick={userPopover.handleOpen}
              ref={userPopover.anchorRef}
              src="/assets/avatar.png"
              sx={{ cursor: 'pointer' }}
            />
          </Stack>
        </Stack>
      </Box>
      <UserPopover anchorEl={userPopover.anchorRef.current} onClose={userPopover.handleClose} open={userPopover.open} />
      <MobileNav
        onClose={() => {
          setOpenNav(false);
        }}
        open={openNav}
      />
    </React.Fragment>
  );
}
